import { render, staticRenderFns } from "./CompanyBack.vue?vue&type=template&id=7cf550b3&scoped=true"
import script from "./CompanyBack.vue?vue&type=script&lang=js"
export * from "./CompanyBack.vue?vue&type=script&lang=js"
import style0 from "./CompanyBack.vue?vue&type=style&index=0&id=7cf550b3&prod&scoped=true&lang=css"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=7cf550b3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf550b3",
  null
  
)

export default component.exports